<div #actionList
    class="≈bg-surface-default ≈rounded-3 sm:≈rounded md:≈rounded-md ≈max-w-4xl ≈shadow-sm sm:≈shadow md:≈shadow-md
        lg:≈shadow-lg xl:≈shadow-xl ≈transition-all ≈duration-300 ≈overflow-hidden ≈text-sm md:≈text-base xl:≈text-lg ≈font-normal
        ≈text-default-text ≈z-50 focus:≈outline-none"
    [ngClass]="{
        '≈fixed': !!triggerRef,
        '≈max-h-0': !isTriggerFocused,
        '≈max-h-120': isTriggerFocused || !triggerRef
    }"
    [style.left.px]="actionListPosition.left" [style.top.px]="actionListPosition.top" (mousedown)="$event.preventDefault(); $event.stopPropagation()">

    {{actionList['navigating']}}

    <ng-content>

    </ng-content>

</div>
